import { EDUCATION_LEVELS } from 'utils/constants/general/educationLevels';
import { PROFESSIONAL_LEVELS } from 'utils/constants/general/professionalLevels';

export function getProfessionalLevelName(levelId: string) {
  const level = PROFESSIONAL_LEVELS.find(({ id }) => id === levelId);
  return level ? level.name : '';
}

export function getEducationLevelName(levelId: string) {
  const level = EDUCATION_LEVELS.find(({ id }) => id === levelId);
  return level ? level.name : '';
}
